import { useState } from 'react';
import StepFormTemplate from "../../templates/step-form.template";
import { useNavigate } from 'react-router-dom';
import AuthorizationForm from '../../templates/authorization-form.template';

const ApplicationThirdStepScreen = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        termsAccepted: false,
        privacyPolicyAccepted: false,
        creditReportAccepted: false
    });

    const handleChange = (field) => (value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    function handleSubmit() {
        navigate('/app/application/fourth-step');
    }

    const isFormValid = formData.termsAccepted &&
        formData.privacyPolicyAccepted &&
        formData.creditReportAccepted;

    return (
        <div style={styles.mainContainerStyle}>
            <StepFormTemplate
                title="Autorizaciones"
                description="Revisa y acepta los términos y condiciones"
                currentStep={4}
                totalSteps={5}
                submitEnabled={isFormValid}
                onSubmit={handleSubmit}
                onClose={() => { navigate('/') }}
            >
                <AuthorizationForm
                    termsAccepted={formData.termsAccepted}
                    onTermsAcceptedChange={handleChange('termsAccepted')}
                    privacyPolicyAccepted={formData.privacyPolicyAccepted}
                    onPrivacyPolicyAcceptedChange={handleChange('privacyPolicyAccepted')}
                    creditReportAccepted={formData.creditReportAccepted}
                    onCreditReportAcceptedChange={handleChange('creditReportAccepted')}
                />
            </StepFormTemplate>
        </div>

    );
};

const styles = {
    mainContainerStyle: {
        margin: '0 auto',
        padding: window.innerWidth > 700 ? '0 25%' : '0'
    }
}
export default ApplicationThirdStepScreen;
